import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-link"
    }}>{`sp-link`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a link, that when clicked can launch a webpage in the user's default browser.`}</p>
    <p><img alt="Links" src={require("../../assets/sp-link.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/link/"
        }}>{`https://spectrum.adobe.com/page/link/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/link"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/link`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-link href="https://adobe.com">Adobe</sp-link>
`}</code></pre>
    <h2 {...{
      "id": "variations"
    }}>{`Variations`}</h2>
    <h3 {...{
      "id": "over-background"
    }}>{`Over Background`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-link variant="overBackground">This link has more contrast, suitable for rendering over a colored background.</sp-link>
`}</code></pre>
    <h3 {...{
      "id": "quiet"
    }}>{`Quiet`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-link quiet>This is a quiet link</sp-link>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to a click on the link using the `}<inlineCode parentName="p">{`click`}</inlineCode>{` event. However, you cannot prevent the navigation to the URL specified by `}<inlineCode parentName="p">{`href`}</inlineCode>{`. If the `}<inlineCode parentName="p">{`href`}</inlineCode>{` attribute is not specified, no browser will be launched.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourLink").addEventListener("click", evt => {
    console.log("You clicked a link");
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      